// Components==============
// import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import loginUser from 'actions/authentication/login';
import axios from 'axios';
import Button from 'components/UI/Button';
import { TextInput } from 'components/UI/Form/Input';
import Modal from 'components/UI/Modal';
// import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useCloseUrlModal } from 'utilities/useCloseUrlModal';
import { useFormValues } from 'utilities/useFormValues';
import './index.module.scss';
// =========================

export default function LoginModal() {
    const { formValues, handleChange } = useFormValues({
        email: '',
        password: '',
    });

    const [hasError, setError] = useState(false);
    const dispatch = useDispatch();

    const closeUrlModal = useCloseUrlModal();

    useEffect(() => {
        // get cookie we need for loggin in
        axios.get('/sanctum/csrf-cookie').then(() => {});
    }, []);

    function handleSubmit(e) {
        e.preventDefault();
        dispatch(loginUser(formValues)).catch((error) => {
            setError(true);
        });
    }

    return (
        <Modal slug="login-popup">
            <div styleName="content">
                <h2>Inloggen</h2>
                <div styleName="grid">
                    {/* <div styleName="school">
                        <p styleName="heading">Met je school account</p>
                        <div styleName="content">
                            {schools.map((e) => (
                                <motion.div
                                    key={e.name}
                                    styleName="flex"
                                    whileHover={{ x: 3 }}
                                    whileTap={{ x: 0 }}
                                >
                                    <img src={e.image} alt={e.name} />
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </motion.div>
                            ))}
                        </div>
                    </div> */}
                    <div styleName="orion">
                        {/* <p styleName="heading">Met je orion account</p> */}
                        <div styleName="content">
                            <form onSubmit={handleSubmit}>
                                <TextInput
                                    label="E-mailadres *"
                                    name="email"
                                    type="email"
                                    value={formValues.email}
                                    onChange={handleChange}
                                />
                                <TextInput
                                    label="Wachtwoord *"
                                    name="password"
                                    type="password"
                                    value={formValues.password}
                                    onChange={handleChange}
                                />
                                {hasError && (
                                    <p styleName="error">
                                        Deze gegevens zijn helaas niet bekend
                                    </p>
                                )}
                                <Button>Inloggen</Button>
                            </form>
                        </div>
                    </div>
                </div>
                {/* <p styleName="text">
                    Log je voor de eerste keer in en staat je school er niet
                    tussen dan moet je eerst een Orion-account aanmaken.
                </p> */}
                {/* <Button onClick={handleClick}>Account aanmaken</Button> */}
            </div>
        </Modal>
    );
}
